import { useMemo } from 'react';

import type { PinnedChip } from './evidence-settings-popover';

export const useShortcutMarketplacePins = (pinnedChips: readonly PinnedChip[]) =>
  useMemo(() => {
    const pinnedShortcutIds = new Set<string>();
    const pinnedShortcutLabels = new Set<string>();
    const customShortcuts: PinnedChip[] = [];

    for (const chip of pinnedChips) {
      pinnedShortcutIds.add(chip.id);
      pinnedShortcutLabels.add(chip.label);
      if (!chip.isDefault) customShortcuts.push(chip);
    }

    return { pinnedShortcutIds, pinnedShortcutLabels, customShortcuts };
  }, [pinnedChips]);
